import { render, staticRenderFns } from "./ReportsModeration.vue?vue&type=template&id=5e95eb21&lang=pug"
import script from "./ReportsModeration.vue?vue&type=script&lang=js"
export * from "./ReportsModeration.vue?vue&type=script&lang=js"
import style0 from "./ReportsModeration.vue?vue&type=style&index=0&id=5e95eb21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports